import { isEBSEmbedded } from '@xmatters/common/context/ebsGlobalContext';
import * as featureTogglesActions from 'actions/featureToggles';

const defaultState = {
  data: null,
  status: 'NOT_LOADED',
  featureToggleMap: {},
};

export default function featureToggles(state = defaultState, action) {
  switch (action.type) {
    case featureTogglesActions.LOAD_START:
      return {
        ...state,
        status: 'LOADING',
      };
    case featureTogglesActions.LOAD_SUCCESS:
      return {
        ...state,
        ...action.payload,
        featureToggleMap: action.payload.data.reduce((acc, { name, value }) => {
          acc[name] = value;
          if (name === 'INCIDENT_MANAGEMENT_MVP' && isEBSEmbedded()) {
            acc[name] = 'true';
          }
          return acc;
        }, {}),
        status: 'LOADED',
      };
    case featureTogglesActions.LOAD_FAIL:
      return {
        ...state,
        data: null,
        featureToggleMap: {},
        status: 'FAILED',
      };
    default:
      return state;
  }
}
